// debugKeys.js
const DEBUG_KEYS = {
  DEBUG_MODE: 'debug_mode',
  // Add more keys as needed
};

export default DEBUG_KEYS;
